module.exports = __webpack_public_path__ + "img/autobot.ae85515d.svg";